import { useContext } from 'react';
import PropTypes from 'prop-types';
import AuthContext from '../contexts/FirebaseContext';
import { DevRoleProvider } from '../contexts/DevRoleContext';

/**
 * Wrapper component that provides DevRoleContext with the real user role.
 * This needs to be a separate component to access AuthContext.
 */
function DevRoleWrapper({ children }) {
  const auth = useContext(AuthContext);
  const realRole = auth.user?.role || '';

  return <DevRoleProvider realRole={realRole}>{children}</DevRoleProvider>;
}

DevRoleWrapper.propTypes = { children: PropTypes.node.isRequired };

export default DevRoleWrapper;
